<template>
  <full-width>
    <back-button />
    <div
      class="flex flex-col items-center justify-center w-full mx-auto space-y-6 max-w-7xl"
      data-e2e-attr="logout-page"
    >
      <div class="max-w-2xl space-y-3 text-center">
        <p class="mt-3 ml-3 mr-3 text-2xl font-bold tmsk-blue-text">
          By logging out, you will need to login again to pre-order or view your
          purchases.
        </p>
      </div>
      <div class="mt-5 flex flex-wrap items-center justify-center">
        <div class="flex px-1">
          <span class="mt-3 rounded-full shadow-sm sm:mt-0 sm:col-start-1">
            <button
              type="button"
              class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white border border-transparent rounded-full tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
              @click="() => $router.go(-1)"
              data-e2e-attr="logout-page=back-btn"
            >
              Go Back
            </button>
          </span>
        </div>
        <div class="flex px-1">
          <span class="mt-3 rounded-full shadow-sm sm:mt-0 sm:col-start-1">
            <button
              type="button"
              data-e2e-attr="logout-button"
              class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white border border-transparent rounded-full tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
              @click="handleLogout"
            >
              Logout
            </button>
          </span>
        </div>
      </div>
    </div>
  </full-width>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

import BackButton from '../../../components/BackButton'
import FullWidth from '../../../components/Layout/FullWidth'
import * as LogoutService from './Logout.service'

export default {
  name: 'Logout',
  metaInfo () {
    return {
      title: 'StayMasked',
      // meta: [
      //   { property: 'og:title', content: 'StayMasked' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'StayMasked' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-01.jpg' }
      // ],
      link: [{ rel: 'canonical', href: window.location.href }]
    }
  },
  components: {
    BackButton,
    FullWidth
  },
  computed: {
    ...mapState(['isLoggedIn']),
    ...mapGetters(['token'])
  },
  mounted () {
    if (!this.isLoggedIn) this.$router.push({ name: 'Home' })
  },
  methods: {
    ...mapMutations(['setIsLoading']),
    async handleLogout () {
      this.setIsLoading(true)
      const token = this.token

      await LogoutService.logout(this.$cookies, token)
      this.setIsLoading(false)

      this.rerouteToHome()
    },
    rerouteToHome () {
      console.log('Reroute is called')
      document.location.href = '/'
    }
  }
}
</script>

<style scoped></style>
